@if (models?.length || client.isCms) {
<div>
    <div class="flex flex-justify-between">
        <p class="p-b p-t-6"
           sizeClass="XL:h3, SM: h4"
           *iCms="'title' of component"></p>
        <div class="flex m-t-6 p-b-5 z-1 swiper-nav-buttons">
            <button class="b-radius-max m-r-2 flex flex-justify-center flex-middle swiper-nav-button"
                    [ngClass]="'item-prev-' + uid"
                    type="button"
                    [attr.aria-label]="'Previous slide' | translate">
                <i class="icon-chevron-left col-6 fs-3 inline-flex"
                   aria-hidden="true">
                </i>
            </button>
            <button class="b-radius-max flex flex-justify-center flex-middle swiper-nav-button"
                    [ngClass]="'item-next-' + uid"
                    type="button"
                    [attr.aria-label]="'Next slide' | translate">
                <i class="icon-chevron-right col-6 fs-3 inline-flex"
                   aria-hidden="true">
                </i>
            </button>
        </div>
    </div>
    <carousel class="w-12 p-b-7 product-carousel"
              [ngClass]="(component.carouselVariant === 'smaller_squares' || component.carouselVariant === 'smaller_squares_title') ? 'smaller-squares' : ''"
              [slidesPerView]="2"
              [spaceBetween]="20"
              [loop]="false"
              [navigation]="{
                                    nextEl: '.item-next-' + uid,
                                    prevEl: '.item-prev-' + uid
                                }">
        @for (model of filteredModels; track trackById(index, model); let index = $index) {
        <ng-template swiperSlide
                     class="p-b-0">
            <product class="w-12"
                     [listPosition]="index + 1"
                     [model]="model"
                     [klevuRecommendationId]="klevuRecommendationId"
                     [klevuTypeId]="klevuTypeId"
                     [quickAdd]="true"
                     [listName]="listData"
                     [sendTracking]="true">
        </product>
        </ng-template>
        }
    </carousel>
</div>
}
